function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useState } from "react";
import { StyledClickableTagsGrid } from "./clickable-tags-grid.scss";
import TagComponent from "./tag/tag-component";
import AnimatedTextComponent from "./animated-text/animated-text-component";
import DefaultProps from "./default-props";
const ClickableTagsGrid = ({ tags, tagsTitle, onTagSelectionChange, renderCta, tagsTitleAlignment, handleTagHover, preSelectedTag })=>{
    const preSelectedTags = preSelectedTag ? [
        preSelectedTag
    ] : [];
    const [selectedTags, setSelectedTags] = useState(preSelectedTags);
    const handleCardClick = (tag)=>{
        const updatedSelectedTags = selectedTags.includes(tag) ? selectedTags.filter((selectedTag)=>selectedTag !== tag) : [
            ...selectedTags,
            tag
        ];
        setSelectedTags(updatedSelectedTags);
        onTagSelectionChange && onTagSelectionChange(updatedSelectedTags);
    };
    return /*#__PURE__*/ _jsxs(StyledClickableTagsGrid, {
        tagsTitleAlignment: tagsTitleAlignment,
        className: "clickable-tags-grid",
        children: [
            /*#__PURE__*/ _jsx(AnimatedTextComponent, {
                text: tagsTitle
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tags-container",
                children: tags === null || tags === void 0 ? void 0 : tags.map((tag, index)=>/*#__PURE__*/ _createElement(TagComponent, _object_spread_props(_object_spread({}, tag), {
                        key: index,
                        selected: selectedTags.includes(tag),
                        onClick: ()=>handleCardClick(tag),
                        handleTagHoverStart: ()=>handleTagHover(tag),
                        handleTagHoverEnd: ()=>handleTagHover(null)
                    })))
            }),
            renderCta && /*#__PURE__*/ _jsx("div", {
                className: "tags-cta-container",
                children: renderCta()
            })
        ]
    });
};
ClickableTagsGrid.defaultProps = DefaultProps;
export default ClickableTagsGrid;
